var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var NotificationNode_1, NotificationDeliveryNode_1;
import { GraphQLURL } from "graphql-scalars";
import { DateTime } from "luxon";
import { Field, ObjectType } from "type-graphql";
import { AccessControlAuthorized } from "../../authorization/AccessControlAuthorized.js";
import { Node } from "../relay.js";
import { DateTimeScalar } from "../scalars/DateTimeISO.js";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
import { TimestampedResource } from "./Resource.js";
let NotificationNode = NotificationNode_1 = class NotificationNode extends TimestampedResource {
    id;
    title;
    body;
    url;
    deliveryIssue;
    deliveryIssueAcknowledgedAt;
    sendAt;
    startedSendingAt;
    text() {
        return `${this.title} (${this.sendAt?.toLocaleString(DateTime.DATETIME_SHORT) ?? this.startedSendingAt?.toLocaleString(DateTime.DATETIME_SHORT) ?? "unscheduled"})`;
    }
    getUniqueId() {
        return this.id.id;
    }
    static init(init) {
        return NotificationNode_1.createInstance().withValues(init);
    }
};
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], NotificationNode.prototype, "id", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], NotificationNode.prototype, "title", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], NotificationNode.prototype, "body", void 0);
__decorate([
    Field(() => GraphQLURL, { nullable: true }),
    __metadata("design:type", Object)
], NotificationNode.prototype, "url", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    AccessControlAuthorized("get", ["every", "NotificationNode"], ".deliveryIssue"),
    __metadata("design:type", Object)
], NotificationNode.prototype, "deliveryIssue", void 0);
__decorate([
    Field(() => DateTimeScalar, { nullable: true }),
    AccessControlAuthorized("get", ["every", "NotificationNode"], ".deliveryIssueAcknowledgedAt"),
    __metadata("design:type", Object)
], NotificationNode.prototype, "deliveryIssueAcknowledgedAt", void 0);
__decorate([
    Field(() => DateTimeScalar, {
        nullable: true,
        description: "The time the notification is scheduled to be sent, if null it is either already sent or unscheduled.",
    }),
    __metadata("design:type", Object)
], NotificationNode.prototype, "sendAt", void 0);
__decorate([
    Field(() => DateTimeScalar, {
        nullable: true,
        description: "The time the server started sending the notification.",
    }),
    __metadata("design:type", Object)
], NotificationNode.prototype, "startedSendingAt", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
], NotificationNode.prototype, "text", null);
NotificationNode = NotificationNode_1 = __decorate([
    ObjectType({
        implements: [Node],
    })
], NotificationNode);
export { NotificationNode };
let NotificationDeliveryNode = NotificationDeliveryNode_1 = class NotificationDeliveryNode extends TimestampedResource {
    id;
    sentAt;
    receiptCheckedAt;
    chunkUuid;
    deliveryError;
    text() {
        return this.id.id;
    }
    getUniqueId() {
        return this.id.id;
    }
    static init(init) {
        return NotificationDeliveryNode_1.createInstance().withValues(init);
    }
};
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], NotificationDeliveryNode.prototype, "id", void 0);
__decorate([
    Field(() => DateTimeScalar, {
        nullable: true,
        description: "The time the server sent the notification to Expo for delivery.",
    }),
    __metadata("design:type", Object)
], NotificationDeliveryNode.prototype, "sentAt", void 0);
__decorate([
    Field(() => DateTimeScalar, {
        nullable: true,
        description: "The time the server received a delivery receipt from the user.",
    }),
    AccessControlAuthorized("get", ["every", "NotificationDeliveryNode"], ".receiptCheckedAt"),
    __metadata("design:type", Object)
], NotificationDeliveryNode.prototype, "receiptCheckedAt", void 0);
__decorate([
    Field(() => String, {
        nullable: true,
        description: "A unique identifier corresponding the group of notifications this was sent to Expo with.",
    }),
    AccessControlAuthorized("get", ["every", "NotificationDeliveryNode"], ".chunkUuid"),
    __metadata("design:type", Object)
], NotificationDeliveryNode.prototype, "chunkUuid", void 0);
__decorate([
    Field(() => String, {
        nullable: true,
        description: "Any error message returned by Expo when sending the notification.",
    }),
    AccessControlAuthorized("get", ["every", "NotificationDeliveryNode"], ".deliveryError"),
    __metadata("design:type", Object)
], NotificationDeliveryNode.prototype, "deliveryError", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
], NotificationDeliveryNode.prototype, "text", null);
NotificationDeliveryNode = NotificationDeliveryNode_1 = __decorate([
    ObjectType({
        implements: [Node],
    })
], NotificationDeliveryNode);
export { NotificationDeliveryNode };
//# sourceMappingURL=Notification.js.map